/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PresetCreatePresetType } from './presetCreatePresetType';
import type { PresetCreateVisibility } from './presetCreateVisibility';
import type { PresetItemCreate } from './presetItemCreate';

export interface PresetCreate {
  preset_type: PresetCreatePresetType;
  /**
     * @minLength 1
     * @maxLength 255
     */
  title: string;
  description?: string | null;
  visibility?: PresetCreateVisibility;
  items?: PresetItemCreate[] | null;
  filters_json?: string | null;
  stages_json?: string | null;
}
